import { Ellipsis } from 'lucide-react'
import React, { useState } from 'react'
import { Button, Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'

const NotificationOptions = ({ options }) => {
  const { role } = useAuth()
  const [show, setShow] = useState(false)

  if (!options) {
    return null // or return a fallback UI
  }

  const { user, clubId, deleteNotification, markRead, read } = options

  const handleMarkRead = () => {
    markRead()
    setShow(false)
  }

  return (
    <>
      <Dropdown show={show} onToggle={(isOpen) => setShow(isOpen)} drop='down-centered'>
        <Dropdown.Toggle
          variant=''
          className="no-arrow d-flex align-items-center justify-content-center rounded-circle p-2 bg-white shadow-btn text-muted border"
        >
          <Ellipsis />
        </Dropdown.Toggle>
        <Dropdown.Menu className="shadow border-0 px-2" style={{ width: "200px" }}>
          {user &&
            <Link to={`/admin/members/view-user/${user}`} className='d-block custom-hover text-dark text-decoration-none fw-semibold px-3 py-2 rounded'>
              View user
            </Link>
          }
          {clubId &&
            <Link to={role === "admin" ? `/admin/clubs/view-club/${clubId}` : `/user/clubs/view-club/${clubId}`} className='d-block custom-hover text-dark text-decoration-none fw-semibold px-3 py-2 rounded'>
              View club
            </Link>
          }
          {!read && <Button
            onClick={handleMarkRead}
            variant=''
            className='d-flex align-items-center w-100 text-start border-0 custom-hover text-dark text-decoration-none fw-semibold px-3 py-2 rounded'
          >
            Mark as read
          </Button>
          }
          {deleteNotification && <Button
            onClick={() => deleteNotification()}
            variant=''
            className='d-flex align-items-center w-100 text-start border-0 custom-hover text-danger text-decoration-none fw-semibold px-3 py-2 rounded'
          >
            Delete
          </Button>
          }
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default NotificationOptions